import { render, staticRenderFns } from "./TsSnowIt.vue?vue&type=template&id=83c939da&scoped=true"
import script from "./TsSnowIt.vue?vue&type=script&lang=js"
export * from "./TsSnowIt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83c939da",
  null
  
)

export default component.exports